/* eslint-disable import/no-cycle */
import axios from 'axios'
import store from '../utils/store'
import {
  API_ACCEPT_DELIVERY,
  API_CANCEL_ORDER,
  API_CREATE_OPTION,
  API_CREATE_OPTION_ITEM,
  API_CREATE_PRINT_ORDER,
  API_CREATE_PRODUCT,
  API_CREATE_SECTION,
  API_DELETE_CONFIGURATION_USER_SERVICE_PRICE,
  API_DELETE_DELIVERY_ZONE,
  API_DELETE_DISTRICTS,
  API_DELETE_OPEN_CITIES,
  API_DELETE_OPTION,
  API_DELETE_PRODUCT,
  API_DELETE_SECTION,
  API_DELETE_SUB_LOCALITIES,
  API_DELETE_SUPPORT,
  API_DELETE_USER_SERVICE_PRICE,
  API_GENERATE_ACCESS_TOKEN_HUBRISE,
  API_GET_ALL_USERS,
  API_GET_BILLING_SHOP,
  API_GET_CANCELED_ORDER,
  API_GET_COMPANY_SHOP_IDS,
  API_GET_COMPLETED_ORDERS,
  API_GET_CONFIGURATION_SERVICE_PRICE,
  API_GET_CUSTOMER_ORDERS,
  API_GET_FIRST_BILLING,
  API_GET_GEOCODE_FROM_ADDRESS,
  API_GET_LAST_BILLING,
  API_GET_ONE_SHOP,
  API_GET_PLACE_AUTOCOMPLETE,
  API_GET_PLACE_DETAIL,
  API_GET_ROLES_AND_PERMISSIONS,
  API_GET_SALES_SHOP,
  API_GET_SHOP_USERS,
  API_LUNCH_DELIVERY,
  API_NOTIFICATION,
  API_PREPARE_ORDER,
  API_READY_TO_TAKEAWAY,
  API_REFUND_PAYMENT,
  API_SYNCHRONIZE_MENU_HUBRISE,
  API_UPDATE_AUTOACCEPT,
  API_UPDATE_CITY_NAME,
  API_UPDATE_CONFIGURATION_ACTIVATION,
  API_UPDATE_CONFIGURATION_PAYMENT_AND_SALES_TYPE,
  API_UPDATE_DELIVEROO_CGU,
  API_UPDATE_DELIVERY_DRIVER_SERVICE_PRICE,
  API_UPDATE_DELIVERY_USER_SERVICE_PRICE,
  API_UPDATE_DELIVERY_ZONE_NAME,
  API_UPDATE_DESIGN_MOBILE,
  API_UPDATE_DESIGN_WEB,
  API_UPDATE_DESIGN_WEB_MOBILE,
  API_UPDATE_DISTRICTS,
  API_UPDATE_DRIVER_SERVICE_PRICE,
  API_UPDATE_DRIVERS_PAYMENT_VALUES,
  API_UPDATE_EXPIRED_PROMOTION,
  API_UPDATE_MENU_POSITION,
  API_UPDATE_NEW_PRODUCTS,
  API_UPDATE_NOTIFICATION,
  API_UPDATE_OPTION,
  API_UPDATE_OPTION_ITEM,
  API_UPDATE_ORDER_SETTINGS,
  API_UPDATE_PRODUCT,
  API_UPDATE_PRODUCT_STOCK,
  API_UPDATE_SECTION,
  API_UPDATE_SECTION_ACTIVATION,
  API_UPDATE_SECTIONS,
  API_UPDATE_SHOP_HOURS,
  API_UPDATE_SHOP_PRINTER,
  API_DELETE_SPECIAL_HOUR,
  API_GET_CONFIGURATION,
  API_UPDATE_WEBAPP_KEYWORDS,
  API_UPDATE_WEBAPP_CART_PHRASE,
  API_UPDATE_SHOP_LAUNCH,
  API_UPDATE_SHOP_PAYMENT_AND_SALES_TYPE,
  API_UPLOAD_IMAGE,
  API_VALIDATE_ORDER,
  API_UPDATE_SHOP_SETTINGS,
  API_UPDATE_USER_SERVICE_PRICE,
  API_UPDATE_SUB_LOCALITIES,
  API_UPDATE_SPECIAL_HOUR,
  API_GET_DISHOP_MESSAGE,
  SEVERITY,
  API_GET_ALL_MENUS,
  LEVELS,
  API_GET_HOTLINE_AVAILABILITY,
  API_UPDATE_DELIVERY_REMINDER_TRIGGERED
} from '../constants'
import { getFirebaseCustomerId, getIdToken } from './firebase'
import { removeEmptyStringFromObjectValues } from '../utils/tools'
import moment from 'moment'
import { decrypt } from '../utils/encryption'
import { sendPutRequest, sendGetRequest, sendDeleteRequest, sendPostRequest } from '../utils/apiService';
import { logEvent } from 'src/utils/logger'
export const initializeBackend = domain => {
  // domain = 'https://dishop-dev-backend.ngrok.io'
  axios.defaults.baseURL = String(domain);
  return true;
};


export const generateHubriseAccess = async authorizationCode => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
  await sendPostRequest(
    API_GENERATE_ACCESS_TOKEN_HUBRISE,
    { shopId, authorizationCode },
    { Authorization: `Bearer ${idToken}` }
  );
};

export const createProduct = async (product, sectionKey, shopIds = []) => {
  const idToken = await getIdToken();
  const { shopId, companyId } = store.getState().user;
  delete product.hidden // FIX when hidden = true disabled fields are forced to true in backend which leads to undesired behavior

  const functionDetails = {
    fonctionName: 'createProduct',
    descriptionFonction: 'Création d\'un produit',
    paramsFonction: {
      product,
      sectionKey,
      shopIds,
    },
  };
  await sendPostRequest(
    API_CREATE_PRODUCT(companyId, shopId, sectionKey),
    { product, shopIds },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
};

export const updateProduct = async (
  product,
  sectionKey,
  productKey,
  shopIds
) => {
  const idToken = await getIdToken();
  const { shopId, companyId } = store.getState().user;

  delete product.hidden; // FIX when hidden = true disabled fields are forced to true in backend which leads to undesired behavior

  const functionDetails = {
    fonctionName: 'updateProduct',
    descriptionFonction: 'Mise à jour d\'un produit',
    paramsFonction: {
      product,
      sectionKey,
      productKey,
      shopIds,
    },
  };

  await sendPutRequest(
    API_UPDATE_PRODUCT(companyId, shopId, sectionKey, productKey),
    { product, shopIds },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
};


export const deleteProduct = async (key, sectionKey, synchronize, shops) => {
  const idToken = await getIdToken();
  const { shopId, companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'deleteProduct',
    descriptionFonction: `Suppression d'un produit`,
    paramsFonction: {
      key, sectionKey, synchronize, shops
    },
  };
  const { data } = await sendPostRequest(
    API_DELETE_PRODUCT,
    { shopId, sectionKey, key, keepSection: true, synchronize, shops },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    true,
    functionDetails
  );
  return data;
};
export const updateSection = async (section, sectionKey, shopIds = []) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  delete section['iconCompressedUrl'];
  const functionDetails = {
    fonctionName: 'updateSection',
    descriptionFonction: `Mise à jour d'une section`,
    paramsFonction: {
      section, sectionKey, shopIds
    },
  }
  await sendPutRequest(
    API_UPDATE_SECTION(companyId, shopId, sectionKey),
    {
      section,
      shopIds
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
};

export const createSection = async (section, shopIds = []) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'createSection',
    descriptionFonction: `Création d'une section`,
    paramsFonction: {
      section, shopIds
    },
  }
  await sendPostRequest(
    API_CREATE_SECTION(companyId, shopId),
    {
      section,
      shopIds
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
};

export const synchronizeMenuHubrise = async () => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'synchronizeMenuHubrise',
    descriptionFonction: `Synchronisation du menu hubrise`
  }
  await sendPostRequest(
    API_SYNCHRONIZE_MENU_HUBRISE,
    { shopId, replace: true },
    { Authorization: `Bearer ${idToken}` },
    null,
    true,
    functionDetails
  );
};
export const createOptionCategory = async (optionCategory, shopIds = []) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const option = removeEmptyStringFromObjectValues({ ...optionCategory });
  const functionDetails = {
    fonctionName: 'createOptionCategory',
    descriptionFonction: `Création d'une option`,
    paramsFonction: {
      optionCategory, shopIds
    },
  }
  await sendPostRequest(
    API_CREATE_OPTION(companyId, shopId),
    {
      option,
      shopIds,
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
};
export const updateOptionCategory = async (optionCategory, optionKey, shopIds = []) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const option = removeEmptyStringFromObjectValues({ ...optionCategory });
  const functionDetails = {
    fonctionName: 'updateOptionCategory',
    descriptionFonction: `Mise à jour d'une option`,
    paramsFonction: {
      optionCategory, optionKey, shopIds
    },
  }
  await sendPutRequest(
    API_UPDATE_OPTION(companyId, shopId, optionKey),
    {
      option,
      shopIds,
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
};

export const createOptionCategoryItem = async (optionKey, newItem, shopIds = []) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const item = removeEmptyStringFromObjectValues({ ...newItem });
  const functionDetails = {
    fonctionName: 'createOptionCategoryItem',
    descriptionFonction: `Création d'une item`,
    paramsFonction: {
      optionKey, newItem, shopIds
    },
  }
  await sendPostRequest(
    API_CREATE_OPTION_ITEM(companyId, shopId, optionKey),
    {
      item,
      shopIds,
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false, functionDetails
  );
};

export const updateOptionCategoryItem = async (optionKey, updatedItem, shopIds = []) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const item = removeEmptyStringFromObjectValues({ ...updatedItem });
  const functionDetails = {
    fonctionName: 'updateOptionCategoryItem',
    descriptionFonction: `Mise à jour d'une item`,
    paramsFonction: {
      optionKey, updatedItem, shopIds
    },
  }
  await sendPutRequest(
    API_UPDATE_OPTION_ITEM(companyId, shopId, optionKey, updatedItem.key),
    {
      item,
      shopIds,
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
};

export const deleteOptionCategory = async (categoryKey, synchronize, shops, optionKey) => {
  const idToken = await getIdToken();
  const { shopId, companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'deleteOptionCategory',
    descriptionFonction: `Suppression d'une option`,
    paramsFonction: {
      categoryKey, synchronize, shops, optionKey
    },
  }
  await sendPostRequest(
    API_DELETE_OPTION,
    {
      shopId,
      key: categoryKey,
      optionKey,
      synchronize,
      keepCategory: true,
      shops
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    true,
    functionDetails
  );
};
export const uploadImage = async image64 => {
  const idToken = await getIdToken();
  const { shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'uploadImage',
    descriptionFonction: `Téléchargement d'une image`,
    paramsFonction: {
      image64
    },
  }
  const { data = '' } = await sendPostRequest(
    API_UPLOAD_IMAGE,
    {
      shopId,
      image64
    },
    { Authorization: `Bearer ${idToken}` },
    null, true, functionDetails
  );
  return data;
};

export const mooveOrderToCook = async (order, preparationTime, logMessage) => {
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'mooveOrderToCook',
    descriptionFonction: `Déplacement d\'une commande vers l\'état "à cuisiner`,
    paramsFonction: {
      order, preparationTime
    },
  }
  await sendPostRequest(
    API_PREPARE_ORDER,
    {
      customerId: order.id,
      preparationTime,
      chargeId: order.chargeId
    },
    { Authorization: `Bearer ${idToken}` },
    null, true,
    functionDetails,
    logMessage, SEVERITY.HIGH
  );
};

export const mooveOrderToTakeAway = async (order) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'mooveOrderToTakeAway',
    descriptionFonction: `Transition de commande vers le statut "À emporter"`,
    paramsFonction: {
      chargeId: order?.chargeId, id: order?.id
    },
  }
  await sendPostRequest(
    API_READY_TO_TAKEAWAY(companyId, order?.chargeId, order?.id),
    {

    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails,
    `La commande ${order.id} est prête pour retrait`, SEVERITY.HIGH
  );
};

export const mooveOrderToCancel = async (order, cancelReason) => {
  const idToken = await getIdToken();
  const cancellation = {
    canceledBy: 'shop',
    cancelReason,
    chargeId: order.chargeId
  };
  const functionDetails = {
    fonctionName: 'mooveOrderToCancel',
    descriptionFonction: `Annulation d'une commande`,
    paramsFonction: {
      order, cancellation
    },
  }
  await sendPostRequest(
    API_CANCEL_ORDER,
    {
      customerId: order.id,
      cancellation,
      chargeId: order.chargeId
    },
    { Authorization: `Bearer ${idToken}` },
    null, true, functionDetails, '', SEVERITY.HIGH
  );
};

export const refundOrder = async (order, isPastOrder) => {
  const { shopId, id: customerId, chargeId } = order;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'refundOrder',
    descriptionFonction: `Rembourser une commande`,
    paramsFonction: {
      shopId, id: customerId, chargeId, isPastOrder
    },
  }
  await sendPostRequest(
    API_REFUND_PAYMENT,
    {
      shopId,
      customerId,
      chargeId,
      isPastOrder
    },
    { Authorization: `Bearer ${idToken}` },
    null, true, functionDetails
  );
};

export const mooveOrderToPastOrder = async (order) => {
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'mooveOrderToPastOrder',
    descriptionFonction: `Archivage d\'une commande dans l\'historique`,
    paramsFonction: {
      customerId: order.id,
      validatedBy: 'shop',
      chargeId: order.chargeId

    },
  }
  await sendPostRequest(
    API_VALIDATE_ORDER,
    {
      customerId: order.id,
      validatedBy: 'shop',
      chargeId: order.chargeId
    },
    { Authorization: `Bearer ${idToken}` },
    null, true, functionDetails,
    `La commande  ${order.id} a été validée`, SEVERITY.HIGH
  );
};

export const getCustomerOrders = async customerId => {
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'mooveOrderToPastOrder',
    descriptionFonction: `Archivage d\'une commande dans l\'historique`,
    paramsFonction: {
      customerId
    },
  }
  const response = await sendGetRequest(
    API_GET_CUSTOMER_ORDERS,
    {
      customerId
    },
    { Authorization: `Bearer ${idToken}` },
    true, functionDetails
  );
  return response.data;
};

export const getSales = async (shopId, startAt, endAt) => {
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'getSales',
    descriptionFonction: `Ventes et stock`,
    paramsFonction: {
      shopId, startAt, endAt
    },
  }
  const response = await sendPostRequest(
    API_GET_SALES_SHOP,
    {
      shopId,
      startAt,
      endAt
    },
    { Authorization: `Bearer ${idToken}` },
    null, true, functionDetails
  );
  return response.data;
};

export const getBilling = async (shopId, startAt, endAt) => {
  const idToken = await getIdToken()
  const functionDetails = {
    fonctionName: 'getBilling',
    descriptionFonction: `Récupération des données de facturation`,
    paramsFonction: {
      shopId, startAt, endAt
    },
  }
  const response = await sendPostRequest(
    API_GET_BILLING_SHOP,
    {
      shopId,
      startAt,
      endAt
    },
    { Authorization: `Bearer ${idToken}` },
    null, true, functionDetails
  );
  return response.data;
};

export const getCompletedOrders = async (shopId, orderBy, equalTo, startAt, endAt) => {
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'getCompletedOrders',
    descriptionFonction: `Récupération des commandes terminées`,
    paramsFonction: {
      shopId, orderBy, equalTo, startAt, endAt
    },
  }
  const response = await sendPostRequest(
    API_GET_COMPLETED_ORDERS,
    {
      shopId,
      orderBy,
      equalTo,
      startAt,
      endAt
    },
    { Authorization: `Bearer ${idToken}` },
    null, true, functionDetails
  );
  return response.data;
};
export const menuSynchronisation = async (resetMenu, resetPrice, updatePaymentTypes) => {
  const { shopId, companyId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'menuSynchronisation',
    descriptionFonction: `Synchronisation du menu`,
    paramsFonction: {
      resetMenu, resetPrice, updatePaymentTypes
    },
  }
  const response = await sendPostRequest(
    `/api/${companyId}/shops/${shopId}/menu/synchronization`,
    {
      updatePaymentTypes,
      resetMenu,
      resetPrice
    },
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    null, false, functionDetails
  );
  return response;
};
export const getAllDrivers = async (isFreelance, withCompletedDelivery) => {
  const { shopId, companyId } = store.getState().user;
  if (shopId && getFirebaseCustomerId()) {
    const idToken = await getIdToken();
    const functionDetails = {
      fonctionName: 'getAllDrivers',
      descriptionFonction: `Récupération de tous  les livreurs`,
      paramsFonction: {
        isFreelance
      },
    }
    const response = await sendGetRequest(
      `/api/${companyId}/shops/${shopId}/drivers`,
      {
        isFreelance, withCompletedDelivery
      },
      { Authorization: `Bearer ${idToken}` },
      true, functionDetails
    );
    return response.data;
  }

};
export const updateManagementFee = async (managementFee) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'updateManagementFee',
    descriptionFonction: `Update management fee configuration`,
    paramsFonction: {
      managementFee
    },
  }
  const response = await sendPostRequest(

    `/api/${companyId}/configuration/management-fees`,

    managementFee
    ,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    null,
    false,
    functionDetails
  );
  return response;
};

export const getLoyaltyPrograms = async () => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'getLoyaltyPrograms',
    descriptionFonction: `Récupération de programme de fidélité`,
  }
  const response = await sendGetRequest(
    `/api/${companyId}/loyalty-programs`,
    {},
    { Authorization: `Bearer ${idToken}` },
    true, functionDetails
  );
  return response.data;
};
export const updateLoyaltyConfiguration = async (configuration) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'updateLoyaltyConfiguration',
    descriptionFonction: `Mise à jour de fidélité`,
    paramsFonction: {
      configuration
    },
  }
  const response = await sendPostRequest(
    `/api/${companyId}/configuration/loyalty`,

    configuration
    ,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    companyId,
    false, functionDetails
  );
  return response;
};
export const addLoyaltyVersion = async (versionName, minBasket, defaultVersion) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'addLoyaltyVersion',
    descriptionFonction: `Crée une nouvelle version du programme de fidélité`,
    paramsFonction: {
      versionName, minBasket, defaultVersion
    },
  }
  const response = await sendPostRequest(
    `/api/${companyId}/loyalty-programs/versions`,

    { versionName, minBasket, defaultVersion }
    ,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    companyId, false, functionDetails
  );
  return response;
};
export const updateLoyaltyVersion = async (versionName, minBasket, defaultVersion, key) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'addLoyaltyVersion',
    descriptionFonction: `Mise à jour d'une version du programme de fidélité`,
    paramsFonction: {
      versionName, minBasket, defaultVersion, key
    },
  }
  const response = await sendPutRequest(
    `/api/${companyId}/loyalty-programs/versions/${key}/configuration`,

    { versionName, minBasket, defaultVersion }
    ,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    companyId, false, functionDetails
  );
  return response;
};
export const deleteLoyaltyVersion = async (key) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'deleteLoyaltyVersion',
    descriptionFonction: `Suppression d'une version du programme de fidélité`,
    paramsFonction: {
      key
    },
  }
  const response = await sendDeleteRequest(
    `/api/${companyId}/loyalty-programs/versions/${key}`,
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    false,
    functionDetails
  );
  return response;
};
export const addVersionShops = async (shopIds, key, confirmedUpdateAction, resetProduct) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'addVersionShops',
    descriptionFonction: `Ajouter des restaurants à une version du programme de fidélité`,
    paramsFonction: {
      shopIds, key
    },
  }
  return sendPostRequest(
    `/api/${companyId}/loyalty-programs/versions/${key}/shops`,

    { shopIds, confirmedUpdateAction, resetProduct }
    ,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    null, false, functionDetails
  );
};
export const addOfferedProducts = async (program, key) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'addOfferedProducts',
    descriptionFonction: `Ajouter des produits offerts à une version du programme de fidélité`,
    paramsFonction: {
      program, key
    },
  }
  return sendPostRequest(
    `/api/${companyId}/loyalty-programs/versions/${key}/products`,
    program,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    companyId,
    false,
    functionDetails
  );

};
export const getDeepLinks = async () => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'getDeepLinks',
    descriptionFonction: `Récupération des liens magiques`,
  }
  const response = await sendGetRequest(
    `/api/${companyId}/deeplinks`,
    {},
    { Authorization: `Bearer ${idToken}` },
    true,
    functionDetails
  );
  return response.data;

};
export const addNewDeepLink = async (campaign, channel) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'addNewDeepLink',
    descriptionFonction: `Ajouter un nouveau lien magique`,
    paramsFonction: {
      campaign, channel
    },
  }
  return sendPostRequest(
    `/api/${companyId}/deeplinks`,
    { campaign, channel },
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    companyId,
    false, functionDetails
  );

};

export const getDeepLinksAnalytics = async (campaign, channel, startDate, endDate, creationDate) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();

  const todayMinus2Days = moment().subtract(2, 'days');

  endDate = moment(endDate).isAfter(todayMinus2Days) ? todayMinus2Days : moment(endDate);

  if (!creationDate || !creationDate && endDate.isAfter(todayMinus2Days)) {
    startDate = moment(startDate).subtract(2, 'days');
  }

  const params = new URLSearchParams({
    campaign,
    channel,
    startDate: moment(startDate).format('YYYY-MM-DD'),
    endDate: moment(endDate).format('YYYY-MM-DD'),
    isRealTime: false
  }).toString();
  const functionDetails = {
    fonctionName: 'getDeepLinksAnalytics',
    descriptionFonction: `Analyse des liens magiques `,
    paramsFonction: {
      campaign, channel, startDate, endDate, creationDate
    },
  }
  const response = await sendGetRequest(
    `/api/${companyId}/deeplinks/analytics?${params}`,
    null,
    {
      Authorization: `Bearer ${idToken}`,
      'Content-Type': 'application/json',
    },
    false,
    functionDetails
  );
  return response.data;

};

export const lunchDelivery = async (order) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'lunchDelivery',
    descriptionFonction: `Démarrer la livraison`,
    paramsFonction: {
      chargeId: order.chargeId, id: order.id
    },
  }
  await sendPostRequest(
    API_LUNCH_DELIVERY(companyId, order?.chargeId, order?.id),
    {},
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails,
    'Je démarre la livraison pour la commande', SEVERITY.HIGH
  );
};
export const acceptDelivery = async (order) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'acceptDelivery',
    descriptionFonction: `Accepter la livraison`,
    paramsFonction: {
      chargeId: order?.chargeId, id: order?.id
    },
  }
  await sendPostRequest(
    API_ACCEPT_DELIVERY(companyId, order?.chargeId, order?.id),
    {},
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails,
    'Livraison acceptée pour la commande', SEVERITY.HIGH
  );
};
export const pushNotification = async ({ title, message, scheduledDate, toAllUsers }) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'pushNotification',
    descriptionFonction: `Envoyer des notifications`,
    paramsFonction: {
      title, message, scheduledDate, toAllUsers
    },
  }
  await sendPostRequest(
    API_NOTIFICATION(companyId),
    {
      toAllUsers,
      shopId: toAllUsers ? null : shopId,
      title,
      message,
      scheduledDate
    },
    { Authorization: `Bearer ${idToken}` },
    null, true, functionDetails
  );

}
export const updatePushNotification = async ({ title, message, scheduledDate, toAllUsers, id }) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updatePushNotification',
    descriptionFonction: `Mise à jour des notifications`,
    paramsFonction: {
      title, message, scheduledDate, toAllUsers
    },
  }
  await sendPutRequest(
    API_UPDATE_NOTIFICATION(companyId, id),
    {
      toAllUsers,
      shopId: toAllUsers ? null : shopId,
      title,
      message,
      scheduledDate
    },
    { Authorization: `Bearer ${idToken}` },
    null, true, functionDetails

  );

}
export const deleteNotification = async (pushNotificationId, isAllUsers) => {
  const { companyId, shopId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'deleteNotification',
    descriptionFonction: `Suppression des notifications`,
    paramsFonction: {
      pushNotificationId, isAllUsers
    },
  }
  const response = await sendDeleteRequest(
    `/api/${companyId}/push-notifications/${pushNotificationId}`,
    { shopId: isAllUsers ? null : shopId },
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    null, true, functionDetails
  );
  return response;
};

export const getPlacesAutocomplete = async (placeInput) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const headers = { Authorization: `Bearer ${idToken}` };
  const data = { placeInput };
  const functionDetails = {
    fonctionName: 'getPlacesAutoComplete',
    descriptionFonction: `Fetch place autocomplete suggestions from Google Places API`,
    paramsFonction: {
      placeInput
    },
  }
  const result = await sendGetRequest(
    API_GET_PLACE_AUTOCOMPLETE(companyId),
    data,
    headers,
    false,
    functionDetails
  );
  return result.data;

}

export const getPlacesDetails = async (placeId) => {
  const { companyId } = store.getState().user;
  const idToken = await getIdToken();
  const headers = { Authorization: `Bearer ${idToken}` };
  const functionDetails = {
    fonctionName: 'getPlacesDetails',
    descriptionFonction: `Fetch place details`,
    paramsFonction: {
      placeId
    },
  }
  const result = await sendGetRequest(
    API_GET_PLACE_DETAIL(companyId, placeId),
    {},
    headers,
    false,
    functionDetails
  );
  return result.data;

}

export const getGeocodeByAddress = async (address) => {
  const idToken = await getIdToken();
  const data = { address };
  const headers = { Authorization: `Bearer ${idToken}` };
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'getGeocodeByAddress',
    descriptionFonction: `Récupération des coordonnées géographiques à partir d'une adresse`,
    paramsFonction: {
      address
    },
  }
  const response = await sendGetRequest(API_GET_GEOCODE_FROM_ADDRESS(companyId), data, headers, false, functionDetails)
  return response.data.results

}
export const updateShopConfigurationAutoAccept = async (enabled, preparationTime) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateShopConfigurationAutoAccept',
    descriptionFonction: `Mise à jour de la configuration d\'acceptation automatique des commandes`,
    paramsFonction: {
      enabled, preparationTime
    },
  }
  await sendPutRequest(
    API_UPDATE_AUTOACCEPT(companyId, shopId),
    {
      enabled, preparationTime
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );

}
export const updateExpiredPromotion = async (shopId, promotionKey, expired) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateExpiredPromotion',
    descriptionFonction: `Mise à jour d'une promotion`,
    paramsFonction: {
      shopId, promotionKey, expired
    },
  }
  await sendPutRequest(
    API_UPDATE_EXPIRED_PROMOTION(companyId, shopId, promotionKey),
    {
      expired
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );

}
export const updateSupportConfiguration = async (charges, support, cancelFee) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateSupportConfiguration',
    descriptionFonction: `Mise à jour du support`,
    paramsFonction: {
      charges, support, cancelFee
    },
  }
  await sendPutRequest(
    API_UPDATE_SHOP_SETTINGS(companyId, shopId),
    {
      charges, support, cancelFee
    },
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );

}
export const updateDeliveryServicePrice = async (isClient, data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const apiPath = isClient ? API_UPDATE_USER_SERVICE_PRICE : API_UPDATE_DRIVER_SERVICE_PRICE
  const functionDetails = {
    fonctionName: 'updateDeliveryServicePrice',
    descriptionFonction: `Mise à jour des tarifs de livraison`,
    paramsFonction: {
      data
    },
  }
  await sendPutRequest(
    apiPath(companyId, shopId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false, functionDetails
  );

}
export const deleteShopDeliveryUserServicePrice = async () => {
  const { companyId, shopId } = store.getState().user;
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'deleteShopDeliveryUserServicePrice',
    descriptionFonction: `Suppression d\'un tarif de livraison`,
  }
  const response = await sendDeleteRequest(API_DELETE_USER_SERVICE_PRICE(companyId, shopId),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    '', functionDetails
  );
  return response;
};
export const updateShopMethodType = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateShopMethodType',
    descriptionFonction: `Mise à jour d'une mode de paiement`,
    paramsFonction: {
      data
    },
  }
  await sendPutRequest(API_UPDATE_SHOP_PAYMENT_AND_SALES_TYPE(companyId, shopId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );

};
export const deleteShopOpenCities = async (cityName) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const response = await sendDeleteRequest(API_DELETE_OPEN_CITIES(companyId, shopId, cityName),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    ''
  );
  return response;
}
export const deleteShopDistrict = async (cityName, districtName) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'deleteShopDistrict',
    descriptionFonction: `Suppression d'un district  de la zone de livraison d'un restaurant`,
    paramsFonction: {
      cityName, districtName
    },
  }
  const response = await sendDeleteRequest(API_DELETE_DISTRICTS(companyId, shopId, cityName, districtName),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    null,
    functionDetails
  );
  return response;
}
export const deleteShopSubLocalities = async (cityName, subLocalityName) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'deleteShopSubLocalities',
    descriptionFonction: `Suppression d'une sous-localité  des zones de livraison du restaurant`,
    paramsFonction: {
      cityName, subLocalityName
    },
  }
  const response = await sendDeleteRequest(API_DELETE_SUB_LOCALITIES(companyId, shopId, cityName, subLocalityName),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    null, functionDetails
  );
  return response;
}

export const updateShopOpenCitiesCityName = async (cityName, data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateShopOpenCitiesCityName',
    descriptionFonction: `Mise à jour du nom d'une ville dans les zones de livraison d'un magasin`,
    paramsFonction: {
      cityName, data
    },
  }
  await sendPutRequest(API_UPDATE_CITY_NAME(companyId, shopId, cityName),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );

}
export const updateShopDeliveryZoneName = async (key, data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateShopDeliveryZoneName',
    descriptionFonction: `Mise à jour du nom d'une ville`,
    paramsFonction: {
      key, data
    },
  }
  await sendPutRequest(API_UPDATE_DELIVERY_ZONE_NAME(companyId, shopId, key),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false, functionDetails
  );

}
export const deleteShopDeliveryZone = async (key) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'deleteShopDeliveryZone',
    descriptionFonction: `Suppression d'une zone de livraison`,
    paramsFonction: {
      key
    },
  }
  const response = await sendDeleteRequest(API_DELETE_DELIVERY_ZONE(companyId, shopId, key),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    null,
    functionDetails
  );
  return response;
}
export const updateShopSubLocalitiesAndDistricts = async (isSubLocality, cityName, data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const apiPath = isSubLocality ? API_UPDATE_SUB_LOCALITIES : API_UPDATE_DISTRICTS
  const functionDetails = {
    fonctionName: 'updateShopSubLocalitiesAndDistricts',
    descriptionFonction: `Mise à jour de sous-localités et  des districts`,
    paramsFonction: {
      isSubLocality, cityName, data
    },
  }
  await sendPutRequest(apiPath(companyId, shopId, cityName),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false, functionDetails
  );
}
export const updateShopSpecialHour = async (specialHourKey, data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateShopSpecialHour',
    descriptionFonction: `Mise à jour d'une horaire spécifique`,
    paramsFonction: {
      data
    },
  }
  await sendPutRequest(API_UPDATE_SPECIAL_HOUR(companyId, shopId, specialHourKey),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
}
export const updateShopInformation = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateShopInformation',
    descriptionFonction: `Mise à jour des informations d'un magasin`,
    paramsFonction: {
      data
    },
  }
  await sendPutRequest(API_UPDATE_SHOP_LAUNCH(companyId, shopId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false, functionDetails
  );
}
export const updateShopHours = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateShopHours',
    descriptionFonction: `Mise à jour des horaires`,
    paramsFonction: {
      data
    },
  }
  await sendPutRequest(API_UPDATE_SHOP_HOURS(companyId, shopId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
}
export const updateShopPrinter = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateShopPrinter',
    descriptionFonction: `Mise à jour d'une imprimante`,
    paramsFonction: {
      data
    },
  }
  await sendPutRequest(API_UPDATE_SHOP_PRINTER(companyId, shopId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
}
export const deleteShopSpecialHour = async (specialHourKey) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'deleteShopSpecialHour',
    descriptionFonction: `Suppression d'une horaire spécifique`,
    paramsFonction: {
      specialHourKey
    },
  }
  const response = await sendDeleteRequest(API_DELETE_SPECIAL_HOUR(companyId, shopId, specialHourKey),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    '',
    functionDetails
  );
  return response;
}
export const getCompanyConfiguration = async (companyId, idToken) => {
  const baseUrl = determineBaseUrl()
  const apiUrl = new URL(API_GET_CONFIGURATION(companyId), baseUrl).toString();
  const functionDetails = {
    fonctionName: 'getCompanyConfiguration',
    descriptionFonction: `Récupération de la configuration générale`,
    paramsFonction: {
      companyId, idToken
    },
  }
  const response = await sendGetRequest(apiUrl,
    null,
    { Authorization: `Bearer ${idToken}` },
    false,
    functionDetails
  );
  return response.data;
};
export const getALLMenus = async () => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'getALLMenus',
    descriptionFonction: `Récupération de tous les menus`,
    paramsFonction: {

    },
  }
  const response = await sendGetRequest(API_GET_ALL_MENUS(companyId),
    null,
    { Authorization: `Bearer ${idToken}` },
    false, functionDetails
  );
  return response.data;
};
export const updateMenuPosition = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateMenuPosition',
    descriptionFonction: `Mise à jour des postions des menus`,
    paramsFonction: {
      data
    },
  }
  await sendPutRequest(API_UPDATE_MENU_POSITION(companyId, shopId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  )
}
export const updateProductStock = async (sectionKey, productKey, data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateProductStock',
    descriptionFonction: `Mise à jour du stock des produits`,
    paramsFonction: {
      sectionKey, productKey, data
    },
  }
  await sendPutRequest(API_UPDATE_PRODUCT_STOCK(companyId, shopId, sectionKey, productKey),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
}
export const updateSectionActivation = async (sectionKey, data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateSectionActivation',
    descriptionFonction: `Activer/Désactiver une section`,
    paramsFonction: {
      sectionKey, data
    },
  }
  await sendPutRequest(API_UPDATE_SECTION_ACTIVATION(companyId, shopId, sectionKey),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
}
export const updateSections = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateSections',
    descriptionFonction: `Mise à jour des sections`,
    paramsFonction: {
      data
    },
  }
  await sendPutRequest(API_UPDATE_SECTIONS(companyId, shopId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
}

export const getInvoiceBilling = async (isFirst) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'getInvoiceBilling',
    descriptionFonction: `Récupération des données de facturation`,
    paramsFonction: {
      isFirst
    },
  }
  const apiPath = isFirst ? API_GET_FIRST_BILLING : API_GET_LAST_BILLING;
  const response = await sendGetRequest(apiPath(companyId),
    null,
    { Authorization: `Bearer ${idToken}` },
    false,
    functionDetails
  );
  return response.data;
};
export const getCanceledOrder = async (userId, orderId) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'getCanceledOrder',
    descriptionFonction: `Récupération des commandes annulées`,
    paramsFonction: {
      userId, orderId
    },
  }
  const response = await sendGetRequest(API_GET_CANCELED_ORDER(companyId, userId, orderId),
    null,
    { Authorization: `Bearer ${idToken}` },
    false,
    functionDetails
  );
  return response.data;
};
export const deleteMenuSection = async (shopId, sectionKey) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'deleteMenuSection',
    descriptionFonction: `Suppression des sections`,
    paramsFonction: {
      shopId, sectionKey
    },
  }
  const response = await sendDeleteRequest(API_DELETE_SECTION(companyId, shopId, sectionKey),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    '',
    functionDetails
  );
  return response;
}
export const deleteSupport = async (userId, orderId) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'deleteSupport',
    descriptionFonction: `Suppression du support`,
    paramsFonction: {
      userId, orderId
    },
  }
  const response = await sendDeleteRequest(API_DELETE_SUPPORT(companyId, userId, orderId),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    '',
    functionDetails
  );
  return response;
}
export const printOrdersCreate = async (userId, orderId, data) => {
  const idToken = await getIdToken();
  const { shopId, companyId } = store.getState().user;
  await sendPostRequest(
    API_CREATE_PRINT_ORDER(companyId, shopId, userId, orderId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
};
export const getOneShop = async (companyId, shopId, idToken) => {
  const functionDetails = {
    fonctionName: 'getOneShop',
    descriptionFonction: `Récupération d'un seul shop`,
    paramsFonction: {
      companyId, shopId,
    },
  }
  const response = await sendGetRequest(API_GET_ONE_SHOP(companyId, shopId),
    null,
    { Authorization: `Bearer ${idToken}` },
    false,
    functionDetails
  );
  return response.data;
};
export const updateConfigurationActivation = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateConfigurationActivation',
    descriptionFonction: `Mise à jour des paramétres d'activation `,
    paramsFonction: {
      data
    },
  }
  await sendPutRequest(API_UPDATE_CONFIGURATION_ACTIVATION(companyId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
}
export const updateDeliveryServiceFee = async (isClient, data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateDeliveryServiceFee',
    descriptionFonction: `Mise à jour des frais de livraison`,
    paramsFonction: {
      companyId, isClient, data,
    },
  }
  const apiPath = isClient ? API_UPDATE_DELIVERY_USER_SERVICE_PRICE : API_UPDATE_DELIVERY_DRIVER_SERVICE_PRICE
  await sendPutRequest(apiPath(companyId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
}
export const updateWebappKeywords = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  await sendPutRequest(API_UPDATE_WEBAPP_KEYWORDS(companyId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
}
export const updateWebappCartPhrase = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  await sendPutRequest(API_UPDATE_WEBAPP_CART_PHRASE(companyId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false
  );
}
export const updateDesignWeb = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateDesignWeb',
    descriptionFonction: `Mise à jour de design application web`,
    paramsFonction: {
      data,
    },
  }
  await sendPutRequest(API_UPDATE_DESIGN_WEB(companyId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
}
export const updateDesignWebMobile = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateDesignWebMobile',
    descriptionFonction: `Mise à jour de design web et  mobile`,
    paramsFonction: {
      data
    },
  }
  await sendPutRequest(API_UPDATE_DESIGN_WEB_MOBILE(companyId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
}
export const updateDesignMobile = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateDesignMobile',
    descriptionFonction: `Mise à jour de design application mobile`,
    paramsFonction: {
      data
    },
  }
  await sendPutRequest(API_UPDATE_DESIGN_MOBILE(companyId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
}
export const updateNewProducts = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateNewProducts',
    descriptionFonction: `Mise à jour des nouveaux produits`,
    paramsFonction: {
      data
    },
  }
  await sendPutRequest(API_UPDATE_NEW_PRODUCTS(companyId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
}
export const updateConfigurationMethodType = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateConfigurationMethodType',
    descriptionFonction: `Mise à jour des modes de paiments et des ventes`,
    paramsFonction: {
      data
    },
  }
  await sendPutRequest(API_UPDATE_CONFIGURATION_PAYMENT_AND_SALES_TYPE(companyId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
}
export const getAllUsers = async (page, filter, withFilter) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;

  const data = withFilter ? { filters: filter } : {
    pagination: {
      batchNumber: 1,
      batchSize: page?.rowsPerPage * (page?.numPage + 1)
    }
  }
  const functionDetails = {
    fonctionName: 'getAllUsers',
    descriptionFonction: `Récupération des tous les utilisateurs`,
    paramsFonction: {
      data
    },
  }
  const response = await sendGetRequest(API_GET_ALL_USERS(companyId),
    data,
    { Authorization: `Bearer ${idToken}` },
    false,
    functionDetails
  );
  return response.data;

};
export const getShopUsers = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'getShopUsers',
    descriptionFonction: `Récupération des utilisateurs d'un seul shop`,
    paramsFonction: {
      data
    },
  }
  const response = await sendGetRequest(API_GET_SHOP_USERS(companyId, shopId),
    data,
    { Authorization: `Bearer ${idToken}` },
    false,
    functionDetails
  );
  return response.data;
};
export const updateConfigurationOrderSettings = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateConfigurationOrderSettings',
    descriptionFonction: `Mise à jour des paramètres de commande`,
    paramsFonction: {
      data
    },
  }
  await sendPutRequest(API_UPDATE_ORDER_SETTINGS(companyId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
}
export const deleteConfigurationUserServicePrice = async () => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'deleteConfigurationUserServicePrice',
    descriptionFonction: `Suppression de la configuration  utilisateur pour les services de livraison`,
    paramsFonction: {

    },
  }
  const response = await sendDeleteRequest(API_DELETE_CONFIGURATION_USER_SERVICE_PRICE(companyId),
    null,
    {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`
    },
    '',
    functionDetails
  );
  return response;
}
export const updateDriversPaymentValues = async (driverId, data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateDriversPaymentValues',
    descriptionFonction: `Mise à jour des valeurs de paiement`,
    paramsFonction: {
      driverId, data
    },
  }
  await sendPutRequest(API_UPDATE_DRIVERS_PAYMENT_VALUES(companyId, driverId),
    data,
    { Authorization: `Bearer ${idToken}` },
    companyId,
    false,
    functionDetails
  );
}
export const generateCsvFileForOneShop = async (data) => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  const response = await axios.get(API_GET_SHOP_USERS(companyId, shopId), {
    params: data,
    headers: { Authorization: `Bearer ${idToken}` },
    responseType: 'blob',
  });
  return response.data;

}
export const generateCsvFileForALLShops = async (data) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const response = await axios.get(API_GET_ALL_USERS(companyId), {
    params: data,
    headers: { Authorization: `Bearer ${idToken}` },
    responseType: 'blob',
  });
  return response.data;
}
export const getCompanyFirebaseCredentials = async (companyId) => {
  const baseUrl = determineBaseUrl()
  const encryptedFirebaseCredentials = await axios({
    method: 'get',
    url: `${baseUrl}/api/firebase/credentials`,
    params: { companyId }
  });
  const decryptedFirebaseCredentials = await decrypt(encryptedFirebaseCredentials?.data)
  return decryptedFirebaseCredentials ? JSON.parse(decryptedFirebaseCredentials) : null
}
const determineBaseUrl = () => {
  const windowUrl = window.location.origin
  if (windowUrl?.includes('dev-dashboard') || !windowUrl || windowUrl?.includes('localhost')) {
    return `https://dev-backend.dishop.co`
  }
  return `https://api.dishop.co`
}
export const getConfigurationServicePrice = async (companyId, idToken) => {
  const functionDetails = {
    fonctionName: 'getConfigurationServicePrice',
    descriptionFonction: `Récupération des prix des services `,
    paramsFonction: {

    },
  }
  const response = await sendGetRequest(API_GET_CONFIGURATION_SERVICE_PRICE(companyId),
    null,
    { Authorization: `Bearer ${idToken}` },
    false,
    functionDetails
  );
  return response.data;
};
export const getCompanyIds = async (companyId, idToken) => {
  const baseUrl = determineBaseUrl()
  const apiUrl = new URL(API_GET_COMPANY_SHOP_IDS(companyId), baseUrl).toString()
  const functionDetails = {
    fonctionName: 'getCompanyIds',
    descriptionFonction: `Récupération des ids des shops `,
    paramsFonction: {
    },
  }
  const response = await sendGetRequest(apiUrl,
    null,
    { Authorization: `Bearer ${idToken}` },
    false,
    functionDetails
  );
  return response.data;
};
export const getRolesAndPermissions = async (companyId, userId, idToken) => {
  try {
    const baseUrl = determineBaseUrl();
    const apiUrl = new URL(API_GET_ROLES_AND_PERMISSIONS(companyId, userId), baseUrl).toString()
    const response = await sendGetRequest(apiUrl,
      { companyId },
      { Authorization: `Bearer ${idToken}` },
      false
    );
    const decryptedUserRoles = await decrypt(response.data)
    return decryptedUserRoles ? JSON.parse(decryptedUserRoles) : null
  } catch (error) {
    logEvent({
      level: LEVELS.ERROR,
      severity: SEVERITY.HIGH,
      message: `Could not fetch roles and permissions ${companyId} : ${error}`,
    });
    throw error
  }
}
export const updateShopsDeliverooCgu = async () => {
  const idToken = await getIdToken();
  const { companyId, shopId } = store.getState().user;
  try {
    await sendPutRequest(
      API_UPDATE_DELIVEROO_CGU(companyId, shopId),
      {},
      { Authorization: `Bearer ${idToken}` }
    );
  } catch (err) {
    logEvent({
      level: LEVELS.ERROR,
      severity: SEVERITY.HIGH,
      message: `Error from ${shopId} in updating shop deliveroo cgu : ${err}`,
    });
  }
}
export const getMessageDishop = async () => {
  const idToken = await getIdToken();
  try {
    const response = await sendGetRequest(
      API_GET_DISHOP_MESSAGE,
      null,
      {
        Authorization: `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
      false
    );
    return response.data
  } catch (err) {
    logEvent({
      level: LEVELS.ERROR,
      severity: SEVERITY.HIGH,
      message: `Error  in getting message dishop: ${err}`,
    });
  }
}
export const getHotlineAvailability = async () => {
  const idToken = await getIdToken();
  const functionDetails = {
    fonctionName: 'getHotlineAvailability',
    descriptionFonction: `Récupération des horaires de disponibilité de la hotline support `
  }
  const response = await sendGetRequest(
    API_GET_HOTLINE_AVAILABILITY,
    null,
    {
      Authorization: `Bearer ${idToken}`,
      'Content-Type': 'application/json',
    },
    true,
    functionDetails
  );
  return response.data

}
export const updateDeliveryReminderTriggered = async (userId, orderId) => {
  const idToken = await getIdToken();
  const { companyId } = store.getState().user;
  const functionDetails = {
    fonctionName: 'updateDeliveryReminderTriggered',
    descriptionFonction: `Mise à jour du flag deliveryReminderTriggered pour la commande`,
    paramsFonction: {
      userId,
      orderId
    },
  };
  await sendPostRequest(API_UPDATE_DELIVERY_REMINDER_TRIGGERED(companyId, userId, orderId),
    null,
    { Authorization: `Bearer ${idToken}` },
    false,
    functionDetails
  );

};